import { NgModule } from '@angular/core';
import { UserComponent } from './user.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../../material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import {
  AccessRightUserManagement,
  AuthGuard,
  BlockPageAuthGuard,
  CanAuthenticationGuard,
} from '../../../utils/authguard';
import { UserUpdateComponent } from './user-update/user-update.component';
import { BrowserModule } from '@angular/platform-browser';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { UserAvsUpdateValidationComponent } from './avs-update-validation/avs-update-validation.component';
import { ErrorMessageComponent } from '../../shared/error-message/error-message.component';
import { LanguagesPipe } from '../../../pipes/languages.pipe';
import { FormControlPipe } from '../../../pipes/formControl.pipe';

const routes = [
  {
    path: 'user/:oid',
    component: UserComponent,
    canActivate: [
      CanAuthenticationGuard,
      AuthGuard,
      AccessRightUserManagement,
      BlockPageAuthGuard,
    ],
  },
];

@NgModule({
  declarations: [
    UserComponent,
    UserUpdateComponent,
    UserAvsUpdateValidationComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MaterialModule,
    BrowserModule,
    ImageCropperComponent,
    ErrorMessageComponent,
    LanguagesPipe,
    FormControlPipe,
  ],
  exports: [UserComponent],
  providers: [
    CanAuthenticationGuard,
    UserUpdateComponent,
    UserAvsUpdateValidationComponent,
  ],
})
export class UserModule {}
